@if (exercise.releaseDate && dayjs(exercise.releaseDate).isAfter(dayjs())) {
    <span
        class="not-released-tag badge bg-warning"
        [class.ms-1]="!noMargin"
        container="body"
        ngbTooltip="{{ 'artemisApp.courseOverview.exerciseList.notReleasedTooltip' | artemisTranslate }}{{ exercise.releaseDate | artemisDate }}"
        jhiTranslate="artemisApp.courseOverview.exerciseList.notReleased"
    ></span>
}
